import { AppVersion } from "@ionic-native/app-version";
import { TrainingClassProvider } from "./../providers/training-class/training-class";
import { MeusTreinosProvider } from "./../providers/meus-treinos";
import { UserClassProvider } from "./../providers/user-class/user-class";
import { Component, ViewChild, HostListener } from "@angular/core";
import {
    Nav,
    Platform,
    Content,
    MenuController,
    IonicApp,
    AlertController,
    LoadingController,
    ViewController,
    NavController,
} from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { Storage } from "@ionic/storage";
import { SplashScreen } from "@ionic-native/splash-screen";

import { EzoomApiProvider } from "../providers/ezoom-api";
import { GlobalProvider } from "../providers/global";
import { UserProvider } from "../providers/user";
import { MenuProvider } from "../providers/menu";
import { NotificationsProvider } from "../providers/notifications";

import { EzoomSvgComponent } from "../components/ezoom-svg/ezoom-svg";

import { TimelineMax } from "gsap";
import { Observable } from "rxjs/Observable";

import { Diagnostic } from "@ionic-native/diagnostic";
import { Geolocation } from "@ionic-native/geolocation";
import { LocationAccuracy } from "@ionic-native/location-accuracy";

@Component({
    templateUrl: "app.html",
    entryComponents: [EzoomSvgComponent],
})
export class MyApp {
    @ViewChild(Nav) nav: Nav;
    @ViewChild(Content) content: Content;

    @HostListener("focusin", ["$event"])
    public onFocus(event) {
        if (
            event.target.tagName === "INPUT" ||
            event.target.tagName === "TEXTAREA"
        ) {
            let content: any = this.nav.getActive().getContent();
            let footer: any = this.nav.getActive().getFooter();
            content.setElementClass("keyboard-opened", true);
            if (footer) {
                footer._elementRef.nativeElement.setAttribute(
                    "hidden",
                    "hidden"
                );
            }
        }
    }
    @HostListener("focusout", ["$event"])
    public onFocusOut(event) {
        if (
            event.target.tagName === "INPUT" ||
            event.target.tagName === "TEXTAREA"
        ) {
            let content: any = this.nav.getActive().getContent();
            let footer: any = this.nav.getActive().getFooter();
            content.setElementClass("keyboard-opened", false);
            if (footer) {
                footer._elementRef.nativeElement.removeAttribute("hidden");
            }
        }
    }

    rootPage: String = "";
    wildCardPages: Array<String>;

    pages: Array<any>;
    userPages: Array<any>;
    politicaPage: any;

    logged: boolean;
    userType: string;
    userData: any;

    // Animações
    previous: ViewController;
    next: ViewController;
    timeline: TimelineMax = new TimelineMax({ paused: true });

    // Firebase
    firebaseToken: string;
    firebaseRegistered: boolean;
    hasNotification: boolean;
    firebasePlugin;

    hideMeusTreinos = true;

    constructor(
        public platform: Platform,
        public app: IonicApp,
        public statusBar: StatusBar,
        public splashScreen: SplashScreen,
        private ezoomApi: EzoomApiProvider,
        private alertCtrl: AlertController,
        private loadingCtrl: LoadingController,
        private menu: MenuController,
        private menuLinks: MenuProvider,
        private global: GlobalProvider,
        private user: UserProvider,
        private diagnostic: Diagnostic,
        private geolocation: Geolocation,
        private locationAccuracy: LocationAccuracy,
        private storage: Storage,
        private trainingClass: TrainingClassProvider
    ) {
        this.wildCardPages = [
            "LoginPage",
            "EsqueciMinhaSenhaPage",
            "RecuperarSenhaPage",
            "AtualizarAppPage",
        ];

        this.subscriptions();
        this.storage.ready().then(() => {
            // Limpa os endereços do rodapé quando o app abre
            this.storage.remove("headquarters");
            // Define página inicial do APP
            this.user.get().then((data) => {
                if (data) {
                    this.trainingClass.setClass(data).then((res) => {
                        if (res) {
                            if (res.status) {
                                this.hideMeusTreinos = false;
                            }
                        }
                    });
                }
                let page =
                    this.nav.getActive() !== undefined
                        ? this.nav.getActive().name
                        : "";
                if (typeof data == "object") {
                    this.global.isLogged(true);
                    // Se está logado e tenta acessar uma das páginas que não necessitam login, direciona para a Home
                    if (this.wildCardPages.indexOf(page) >= 0) {
                        setTimeout(() => {
                            this.nav.setRoot("HomePage", {
                                visualizar_termo: true,
                            });
                            this.initializeApp();
                        }, 0);
                    } else if (page == "") {
                        setTimeout(() => {
                            page = page =
                                this.nav.getActive() !== undefined
                                    ? this.nav.getActive().name
                                    : "";
                            if (page == "") {
                                this.nav.setRoot("HomePage", {
                                    visualizar_termo: true,
                                });
                                this.initializeApp();
                            }
                        }, 0);
                    }
                } else if (this.wildCardPages.indexOf(page) === -1) {
                    // Se não está logado e tenta acessar uma das páginas que necessitam login, direciona para o Login
                    setTimeout(() => {
                        this.nav.setRoot("LoginPage");
                        this.initializeApp();
                    }, 0);
                }
            });
        });
    }

    initializeApp() {
        this.menuLinks.getPages(false).then((pages) => {
            this.pages = pages;
        });
        this.menuLinks.getUserPages().then((pages) => {
            this.userPages = pages;
        });
        this.politicaPage = this.menuLinks.getPolitic();

        this.platform.ready().then(() => {
            if (this.platform.is("cordova")) {
                this.firebasePlugin = (<any>window).FirebasePlugin;
                this.initializePushNotifications();
            }

            // Okay, so the platform is ready and our plugins are available.
            // Here you can do any higher level native things you might need.
            this.statusBar.overlaysWebView(false);
            this.statusBar.styleLightContent();
            this.statusBar.backgroundColorByHexString("#0c4728");
            this.splashScreen.hide();

            this.platform.registerBackButtonAction(() => {
                let activePortal =
                    this.app._loadingPortal.getActive() ||
                    this.app._modalPortal.getActive() ||
                    this.app._toastPortal.getActive() ||
                    this.app._overlayPortal.getActive();

                //activePortal is the active overlay like a modal,toast,etc
                if (activePortal) {
                    activePortal.dismiss();
                    return;
                } else if (this.menu.isOpen()) {
                    // Close menu if open
                    this.menu.close();
                    return;
                }

                if (!this.nav.canGoBack()) {
                    if (this.nav.getActive().name != "HomePage") {
                        this.nav.setRoot("HomePage", {
                            visualizar_termo: true,
                        });
                    } else {
                        this.platform.exitApp();
                    }
                } else {
                    this.nav.pop();
                }
            }, 300);
        });
    }

    // Firebasex changed the behavior of this function, so that will act like native wrapper from @ionic-native/firebase
    onNotificationOpen() {
        return new Observable((observer) => {
            (window as any).FirebasePlugin.onMessageReceived((response) => {
                observer.next(response);
            });
        });
    }

    initializePushNotifications() {
        if (this.platform.is("ios")) {
            this.firebasePlugin.hasPermission((data) => {
                if (data.isEnabled) return true;

                return this.firebasePlugin.grantPermission();
            });
        }

        this.firebasePlugin.getToken((token) => {
            this.firebaseToken = token;
            if (this.logged) {
                this.user.updateDeviceId(token, true);
                this.firebaseRegistered = true;
            } else {
                this.user.updateDeviceId(token);
            }
        });

        this.firebasePlugin.onTokenRefresh((token) => {
            this.firebaseToken = token;
            if (this.logged) {
                this.user.updateDeviceId(token, true);
                this.firebaseRegistered = true;
            } else {
                this.user.updateDeviceId(token);
            }
        });

        this.firebasePlugin.onMessageReceived((data) => {
            // console.log(data);
            this.hasNotification = true;
            let payload = JSON.parse(data.params);

            if (data.tap) {
                if (payload.id_notification) {
                    this.user.readFromPush(
                        payload.id_send,
                        payload.id_notification
                    );
                } else if (payload.id_push) {
                    this.user.readFromCampaignPush(
                        payload.id_send,
                        payload.id_push
                    );
                }
                let eventParams = { notificacao_id: payload.id_notification };
                // console.log("Evento Firebase (notificacao_push_aberta)", eventParams);
                // this.firebasePlugin.logEvent("notificacao_push_aberta", eventParams);

                if (
                    data.page != "NotificacoesPage" &&
                    data.page != "ModalPage"
                ) {
                    this.nav.push(data.page, { params: payload });
                } else {
                    this.nav.push("ModalPage", {
                        item: payload.id_notification,
                    });
                }
            }
        });
    }

    openPage(page) {
        if (page == null || !page.children) {
            if (page.component == null) {
                // Caso o usuário esteje deslogando
                if (page.title == "Sair") {
                    // Coloca loader na tela para impedir outros cliques
                    let loader = this.loadingCtrl.create({
                        content: "Aguarde...",
                        spinner: "crescent",
                        enableBackdropDismiss: false,
                        dismissOnPageChange: true,
                    });
                    loader.present();
                    // Realiza logout
                    this.user.logout();
                    // Vai para login após animação do menu:
                    this.menu.close();
                    setTimeout(() => {
                        this.nav.setRoot(
                            "LoginPage",
                            {},
                            { animate: true, direction: "back" }
                        );
                    }, 300);
                }
            } else {
                let params = {};
                if (page.params) {
                    params = page.params;
                }

                // Reset the content nav to have just this page
                // we wouldn't want the back button to show in this scenario
                this.nav.push(page.component, params, {
                    animate: true,
                    direction: "forward",
                });
                this.menu.close();
            }
        } else if (page.children) {
            page.showChildren = page.showChildren ? false : true;
        }
    }

    private subscriptions() {
        setTimeout(() => {
            this.nav.viewWillLeave.subscribe((next) => {
                this.previous = next;
            });
            this.nav.viewWillEnter.subscribe((next) => {
                this.next = next;
                if (
                    !this.previous ||
                    this.previous.id == "HomePage" ||
                    this.previous.id == "home"
                ) {
                    this.setLogoWithText();
                } else {
                    this.setLogo();
                }
            });

            this.nav.viewDidEnter.subscribe((next) => {
                if (this.next.id == "HomePage" || this.next.id == "home") {
                    this.playEnterAnimation();
                } else {
                    if (
                        this.previous &&
                        (this.previous.id == "HomePage" ||
                            this.previous.id == "home")
                    ) {
                        this.playLeaveAnimation();
                    }
                }
            });
        }, 300);

        this.global.logged$.subscribe((logged) => {
            const currentStatus = this.logged;
            this.logged = logged;

            this.menuLinks.getPages(false).then((pages) => {
                this.pages = pages;
            });
            this.menuLinks.getUserPages().then((pages) => {
                this.userPages = pages;
            });
            this.politicaPage = this.menuLinks.getPolitic();

            if (this.logged) {
                // start recording location
                if (this.platform.is("cordova")) {
                    this.diagnostic
                        .isLocationEnabled()
                        .then((enabled: boolean) => {
                            if (enabled) {
                                this.startTracking();
                            } else {
                                // Pede apenas a cada 72 horas pra não ser muito chato
                                let now = new Date().getTime();
                                this.user
                                    .getTrackPermissionTime()
                                    .then((time) => {
                                        if (time !== null && time <= now) {
                                            this.locationAccuracy
                                                .canRequest()
                                                .then((canRequest: boolean) => {
                                                    // Confere permissão
                                                    if (canRequest) {
                                                        // the accuracy option will be ignored by iOS
                                                        this.locationAccuracy
                                                            .request(
                                                                this
                                                                    .locationAccuracy
                                                                    .REQUEST_PRIORITY_HIGH_ACCURACY
                                                            )
                                                            .then(
                                                                () => {
                                                                    // Se o user ligar o GPS, tudo certo
                                                                    if (
                                                                        this
                                                                            .logged
                                                                    ) {
                                                                        setTimeout(
                                                                            () => {
                                                                                this.startTracking();
                                                                            },
                                                                            700
                                                                        );
                                                                    }
                                                                },
                                                                (error) => {}
                                                            );
                                                    } else {
                                                        // Força pedir permissão
                                                        this.geolocation.getCurrentPosition(
                                                            {
                                                                enableHighAccuracy:
                                                                    false,
                                                            }
                                                        );
                                                    }
                                                });
                                            this.user.setTrackPermissionTime();
                                        }
                                    });
                            }
                        });
                }
            }

            if (currentStatus && !this.logged) {
                // Coloca loader na tela para impedir outros cliques
                let loader = this.loadingCtrl.create({
                    content: "Aguarde...",
                    spinner: "crescent",
                    enableBackdropDismiss: false,
                    dismissOnPageChange: true,
                });
                loader.present();
                // Vaia para tela de Login
                setTimeout(() => {
                    loader.dismiss();
                    this.nav.setRoot(
                        "LoginPage",
                        {},
                        { animate: true, direction: "back" }
                    );
                }, 300);
            }
        });

        // Handle Ezoom API Errors
        this.ezoomApi.error.subscribe((error) => {
            let activePortal =
                this.app._loadingPortal.getActive() ||
                this.app._modalPortal.getActive() ||
                this.app._toastPortal.getActive() ||
                this.app._overlayPortal.getActive();

            let message;

            switch (error.status) {
                case 401:
                    message =
                        "Parece que sua sessão está expirada. Faça o login novamente para continuar";
                    break;
                case 409:
                    message =
                        "A Aplicação foi atualizada e estará disponivel novamente em alguns minutos.";
                    break;
                default:
                    message = "Ocorreu um erro Inesperado";
                    break;
            }

            try {
                let response = JSON.parse(error._body);
                message = response.data === undefined ? message : response.data;
            } catch (e) {}

            //activePortal is the active overlay like a modal,toast,etc
            if (activePortal) {
                activePortal.dismiss();
            }

            if (error.status == 401 || error.status == 409) {
                this.user.logout();
            }

            if (error.status == 409 && this.platform.is("cordova")) {
                this.nav.setRoot(
                    "AtualizarAppPage",
                    { forwarded: true },
                    { animate: true, direction: "back" }
                );
            } else {
                let alertOpts: any = {
                    title: "Ops!",
                    message: message,
                    enableBackdropDismiss: false,
                    buttons: ["Fechar"],
                };

                if (
                    error.method == "retrieve-password/check-hash" ||
                    error.status == 401
                ) {
                    alertOpts.buttons = [
                        {
                            text: "Fechar",
                            role: "cancel",
                            handler: () => {
                                this.nav.setRoot(
                                    "LoginPage",
                                    {},
                                    { animate: true, direction: "back" }
                                );
                            },
                        },
                    ];
                    alertOpts.enableBackdropDismiss = false;
                }

                let alert = this.alertCtrl.create(alertOpts);
                alert.present();
            }
        });
    }

    playEnterAnimation() {
        this.timeline.clear();
        let header: any = this.next.getHeader();

        if (header) {
            let element: any = header._elementRef.nativeElement;
            let content: any = element.querySelector("#logo-component");
            if (content) {
                let logo: any = content.querySelector("#logo");
                let texto: any = content.querySelector("#texto");

                this.timeline.to(texto, 0.3, {
                    x: 0,
                    autoAlpha: 1,
                });

                this.timeline.to(
                    logo,
                    0.3,
                    {
                        xPercent: 0,
                    },
                    "-=0.3"
                );

                this.timeline.play();
            }
        }
    }

    playLeaveAnimation() {
        let header: any = this.next.getHeader();
        if (header) {
            let element: any = header._elementRef.nativeElement;
            let content: any = element.querySelector("#logo-component");
            if (content) {
                let logo: any = content.querySelector("#logo");
                let texto: any = content.querySelector("#texto");

                this.timeline.to(texto, 0.3, {
                    x: -200,
                    autoAlpha: 0,
                });

                this.timeline.to(
                    logo,
                    0.3,
                    {
                        xPercent: "125%",
                    },
                    "-=0.3"
                );

                this.timeline.play();
            }
        }
    }

    setLogo() {
        // console.log('Setting logo to: ', this.next.id);
        let header: any = this.next.getHeader();
        if (header) {
            let element: any = header._elementRef.nativeElement;
            let content: any = element.querySelector("#logo-component");
            if (content) {
                let svg: any = content.querySelector("svg#rj-logo");
                let logo: any = content.querySelector("#logo");
                let texto: any = content.querySelector("#texto");

                this.timeline.set(texto, {
                    x: -200,
                    autoAlpha: 0,
                });

                this.timeline.set(logo, {
                    xPercent: "125%",
                });

                this.timeline.set(svg, {
                    autoAlpha: 1,
                });

                this.timeline.play();
            }
        }
    }

    setLogoWithText() {
        // console.log('Setting logo and text to: ', this.next.id);
        let header: any = this.next.getHeader();
        if (header) {
            let element: any = header._elementRef.nativeElement;
            let content: any = element.querySelector("#logo-component");
            if (content) {
                let svg: any = content.querySelector("svg#rj-logo");
                let logo: any = content.querySelector("#logo");
                let texto: any = content.querySelector("#texto");

                this.timeline.set(texto, {
                    x: 0,
                    autoAlpha: 1,
                });

                this.timeline.set(logo, {
                    xPercent: 0,
                });

                this.timeline.set(svg, {
                    autoAlpha: 1,
                });

                this.timeline.play();
            }
        }
    }

    private startTracking() {
        // console.log('Start GPS');
        this.geolocation
            .getCurrentPosition({
                enableHighAccuracy: false,
            })
            .then((resp) => {
                let coords = {
                    lat: resp.coords.latitude,
                    lng: resp.coords.longitude,
                };
                this.user.registerLocation(coords);
            })
            .catch((err) => {});
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts